import env from 'enviro';
import { CBX_ADD_ADDITIONAL_CONTACTS_SEATS_TOUCHLESS_FLOW, CBX_CLEARBIT_GATE, CBX_FEATURE_STORE_BUSINESS_OBJECTIVES_GATE, CBX_FEATURE_STORE_DEFAULT_CONTENT_GATE, GROWTH_CALCULATED_FEATURES_TRANSLATED_GATE, SEATS_FREE_TO_PRO_TOUCHLESS_FLOW_GATE, SEATS_FREE_TO_STARTER_TOUCHLESS_FLOW_GATE } from '../constants/Gates';
import { CBX_CLEARBIT_FLAG, CBX_FEATURE_STORE_BUSINESS_OBJECTIVES_FLAG, CBX_FEATURE_STORE_DEFAULT_CONTENT_FLAG, SEATS_VERSIONS_FEATURE_FLAG } from '../constants/PublicFeatureFlags';
import { SEATS_ACCESS } from '../constants/Scopes';
import { getIsQAProxy } from './proxyUtils';
import safeLocalStorage from './safeLocalStorage';
export const getIsUngated = (state, {
  gateKey
}) => {
  const {
    gates
  } = state;
  const isQA = env.isQa() || getIsQAProxy();
  const override = safeLocalStorage.getItem(`${gateKey}_OVERRIDE`);

  if (override === 'true' && isQA) {
    return true;
  }

  return !!(gates && gates.indexOf(gateKey) !== -1);
};
export const getIsUngatedForSeats = state => {
  return getIsUngated(state, {
    gateKey: SEATS_VERSIONS_FEATURE_FLAG
  }) || getIsUngated(state, {
    gateKey: SEATS_ACCESS
  });
};
export const getIsUngatedForSeatsFreeToProTouchlessFlow = state => {
  return getIsUngated(state, {
    gateKey: SEATS_FREE_TO_PRO_TOUCHLESS_FLOW_GATE
  });
};
export const getIsUngatedForSeatsFreeToStarterTouchlessFlow = state => {
  return getIsUngated(state, {
    gateKey: SEATS_FREE_TO_STARTER_TOUCHLESS_FLOW_GATE
  });
};
export const getIsUngatedForCBXFeatureStoreBusinessObjectives = state => {
  return getIsUngated(state, {
    gateKey: CBX_FEATURE_STORE_BUSINESS_OBJECTIVES_GATE
  }) || getIsUngated(state, {
    gateKey: CBX_FEATURE_STORE_BUSINESS_OBJECTIVES_FLAG
  });
};
export const getIsUngatedForCBXFeatureStoreDefaultContent = state => {
  return getIsUngated(state, {
    gateKey: CBX_FEATURE_STORE_DEFAULT_CONTENT_GATE
  }) || getIsUngated(state, {
    gateKey: CBX_FEATURE_STORE_DEFAULT_CONTENT_FLAG
  });
};
export const getIsUngatedForCBXClearbit = state => {
  return getIsUngated(state, {
    gateKey: CBX_CLEARBIT_GATE
  }) || getIsUngated(state, {
    gateKey: CBX_CLEARBIT_FLAG
  });
};
export const getIsUngatedForGrowthCalculatedFeaturesTranslated = state => {
  return getIsUngated(state, {
    gateKey: GROWTH_CALCULATED_FEATURES_TRANSLATED_GATE
  });
};
export const getIsUngatedForCBXAddAdditionalContactsSeatsTouchlessFlow = state => {
  return getIsUngated(state, {
    gateKey: CBX_ADD_ADDITIONAL_CONTACTS_SEATS_TOUCHLESS_FLOW
  });
};